import { render, staticRenderFns } from "./PropertyUnit.vue?vue&type=template&id=68bc5ed6&"
import script from "./PropertyUnit.vue?vue&type=script&lang=js&"
export * from "./PropertyUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports